import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { NewInquiriesBadge } from './NewInquiriesBadge';

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-b from-white via-gray-50 to-white dark:from-black dark:via-gray-900 dark:to-black flex items-center justify-center">
        <div className="text-gray-900 dark:text-white text-xl">Načítám...</div>
      </div>
    );
  }

  if (!user || user.role !== 'admin') {
    return <Navigate to="/admin" replace />;
  }

  return (
    <>
      {children}
      <NewInquiriesBadge />
    </>
  );
};

export default ProtectedRoute;
